"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectScheme = exports.selectThemeColor = exports.selectSchemes = void 0;

var _reselect = require("reselect");

var _selectors = require("../editor/selectors");

var selectSchemes = function selectSchemes(state) {
  return state.theme.schemes;
};

exports.selectSchemes = selectSchemes;

var selectSelectedScheme = function selectSelectedScheme(state) {
  return state.theme.selectedScheme;
};

var selectThemeColor = function selectThemeColor(state) {
  return state.theme.color;
};

exports.selectThemeColor = selectThemeColor;
var selectScheme = (0, _reselect.createSelector)([_selectors.selectWidgetScheme, selectSelectedScheme, selectSchemes], function (widgetScheme, selectedScheme, schemes) {
  // If the user manually picked a scheme, this is the one we want to be shown
  if (selectedScheme) {
    return schemes.find(function (scheme) {
      return scheme.name === selectedScheme;
    });
  } // Otherwise, if the widget has an embedded scheme, that's the one we're displaying


  if (widgetScheme) {
    return widgetScheme;
  } // As a fallback, we otherwise display the first scheme available


  return schemes[0];
});
exports.selectScheme = selectScheme;